var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgScore = function SvgScore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 391 321",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person {\r\n        fill: #db6a72\r\n      }\r\n      .person--active {\r\n        fill: #7fc13a;\r\n      }\r\n      .person--half {\r\n        fill: #ffa124;\r\n      }"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.86 55l-.61-4.84a3.32 3.32 0 00-3.3-2.89H97.4a3.32 3.32 0 00-3.3 2.89L93.49 55a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.32 1.32 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.68,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 55l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.84a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.32 1.32 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 55l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.27 2.88l-.64 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 55l-.61-4.85a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.63 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 55l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.6 4.84a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 55l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89L198 55a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.27-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 55l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.84a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.45 1.45 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 55l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.84a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 55l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.65 4.84a1.37 1.37 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.34-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 55l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.84a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 42.61,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 80l-.61-4.84a3.31 3.31 0 00-3.3-2.89h-4.56a3.3 3.3 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.32-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 80l-.61-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.34 1.34 0 00.9.49h10a1.29 1.29 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 80l-.62-4.84a3.3 3.3 0 00-3.3-2.89h-4.55A3.3 3.3 0 00136 75.2l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.29-1.04z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 80l-.61-4.8a3.3 3.3 0 00-3.29-2.89h-4.55a3.3 3.3 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.3-1.04z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 80l-.62-4.84a3.3 3.3 0 00-3.29-2.89H181a3.3 3.3 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.33-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 80l-.61-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.59 4.89a1.38 1.38 0 00.28 1 1.32 1.32 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.27-1.04z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 80l-.62-4.84a3.3 3.3 0 00-3.3-2.89h-4.55a3.3 3.3 0 00-3.29 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.42 1.42 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 80l-.62-4.84a3.3 3.3 0 00-3.3-2.89h-4.54a3.3 3.3 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 80l-.62-4.84a3.3 3.3 0 00-3.29-2.89h-4.55a3.3 3.3 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 80l-.61-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.32 1.32 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 67.66,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 105.08l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.32-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 105.08l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.28 1.28 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 105.08l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.28 1.28 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 105.08l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 105.08l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.33-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 105.08l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.3 1.3 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 105.08l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.28 1.28 0 00.89-.49 1.45 1.45 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 105.08l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.28 1.28 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 105.08l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.28 1.28 0 00.89.49h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 105.08l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.3 1.3 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 92.7,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 130.13l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.32-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 130.13l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.32 1.32 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 130.13l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 130.13l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 130.13l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.33-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 130.13l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 130.13l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.45 1.45 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 130.13l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 130.13l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 130.13l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 117.75,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 155.18l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.32-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 155.18l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.34 1.34 0 00.9.49h10a1.29 1.29 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 155.18l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 155.18l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 155.18l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.33-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 155.18l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.32 1.32 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 155.18l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.42 1.42 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 155.18l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.29 1.29 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 155.18l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.32 1.32 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 155.18l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.32 1.32 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 142.8,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 180.22l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.45 1.45 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.32-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 180.22l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.32 1.32 0 00.9.48h10a1.28 1.28 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 180.22l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 180.22l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 180.22l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.45 1.45 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.33-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 180.22l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.3 1.3 0 00.9.48h10a1.3 1.3 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 180.22l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.45 1.45 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 180.22l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 180.22l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.41 1.41 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 180.22l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.3 1.3 0 00.9.48h10a1.3 1.3 0 00.9-.49 1.4 1.4 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 167.84,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 205.27l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.32-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 205.27l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.32 1.32 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 205.27l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 205.27l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 205.27l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.33-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 205.27l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 205.27l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.45 1.45 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 205.27l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 205.27l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 205.27l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 192.89,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 230.32l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.28 1.28 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.32-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 230.32l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.3 1.3 0 00.9.49h10a1.29 1.29 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 230.32l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 230.32l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.26 1.26 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 230.32l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.43 1.43 0 00.29 1 1.28 1.28 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.33-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 230.32l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.28 1.28 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 230.32l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.42 1.42 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 230.32l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 230.32l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.38 1.38 0 00.29 1 1.28 1.28 0 00.89.49h10a1.27 1.27 0 00.89-.5 1.37 1.37 0 00.31-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 230.32l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.38 1.38 0 00.28 1 1.28 1.28 0 00.9.49h10a1.31 1.31 0 00.9-.5 1.37 1.37 0 00.29-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 217.94,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 255.37l-.61-4.85a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.45 1.45 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.4 1.4 0 00.32-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 255.37l-.61-4.85a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.32 1.32 0 00.9.48h10a1.28 1.28 0 00.9-.49 1.39 1.39 0 00.29-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 255.37l-.62-4.85a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.4 1.4 0 00.31-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 255.37l-.62-4.85a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.4 1.4 0 00.31-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 255.37l-.62-4.85a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.45 1.45 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.4 1.4 0 00.33-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 255.37l-.61-4.85a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.3 1.3 0 00.9.48h10a1.3 1.3 0 00.9-.49 1.39 1.39 0 00.29-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 255.37l-.62-4.85a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.44 1.44 0 00.31-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 255.37l-.62-4.85a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.28 1.28 0 00.89.48h10a1.28 1.28 0 00.89-.49 1.4 1.4 0 00.31-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 255.37l-.62-4.85a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.41 1.41 0 00.29 1 1.3 1.3 0 00.89.48h10a1.26 1.26 0 00.89-.49 1.4 1.4 0 00.31-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 255.37l-.61-4.85a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.4 1.4 0 00.28 1 1.3 1.3 0 00.9.48h10a1.3 1.3 0 00.9-.49 1.39 1.39 0 00.29-.99z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 242.98,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106 280.41l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.56a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.32-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.8,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.86 280.41l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.3 1.3 0 00.9.49h10a1.32 1.32 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.68,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.74 280.41l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.55,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.61 280.41l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.42,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.48 280.41l-.62-4.84a3.31 3.31 0 00-3.29-2.89H181a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.42 1.42 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.33-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.29,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.35 280.41l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.16,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.23 280.41l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.55a3.31 3.31 0 00-3.29 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.45 1.45 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.04,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.1 280.41l-.62-4.84a3.31 3.31 0 00-3.3-2.89h-4.54a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.26 1.26 0 00.89.49h10a1.32 1.32 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.91,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273 280.41l-.62-4.84a3.31 3.31 0 00-3.29-2.89h-4.55a3.31 3.31 0 00-3.3 2.89l-.62 4.85a1.37 1.37 0 00.29 1 1.28 1.28 0 00.89.49h10a1.29 1.29 0 00.89-.49 1.41 1.41 0 00.31-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("g", {
    className: "person"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.84 280.41l-.61-4.84a3.32 3.32 0 00-3.3-2.89h-4.55a3.32 3.32 0 00-3.3 2.89l-.61 4.85a1.37 1.37 0 00.28 1 1.28 1.28 0 00.9.49h10a1.34 1.34 0 00.9-.49 1.4 1.4 0 00.29-1.01z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.65,
    cy: 268.03,
    r: 3.54
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f5f5f5",
    strokeMiterlimit: 10,
    d: "M.5.5h390v320H.5z"
  }))));
};
export default SvgScore;